export interface AccountRecoveryQuestionResponse {
  status: QuestionStatusEnum;
  pergunta: Question;
  secret: string;
}

export enum QuestionStatusEnum {
  FINALIZADO = 'FINALIZADO',
  BLOQUEADO = 'BLOQUEADO',
}

export interface Question {
  id: string;
  pergunta: string;
  respostas: AnswerOptions[];
  status: string;
  resposta: any;
  dataResposta: any;
}

export interface AnswerOptions {
  texto: string;
  id: string;
}

export interface AccountRecoveryQuestionAnswer {
  pergunta: {
    id: string;
  }
  resposta: {
    id: string;
  }
}

export interface AccountRecoveryQuestionAnswerResponse {
  retorno: boolean;
  token: string;
}